import { useEffect, useState } from "react";
import { apiFetch } from "../../../context/AuthContext";

const useModulePermissions = (BASE_URL) => {
    const [modulePermissions, setModulePermissions] = useState(null);
    const [loadingPermissions, setLoadingPermissions] = useState(true);

    useEffect(() => {
        const fetchModulePermissions = async () => {
            try {
                const clientName = localStorage.getItem("clientName", "");
                if (!clientName) {
                    setLoadingPermissions(false);
                    return;
                }

                const response = await apiFetch(
                    `${BASE_URL}/api/configurations/${encodeURIComponent(clientName)}`,
                    { method: "GET" }
                );
                const json = await response.json();

                if (json && json.data) {
                    setModulePermissions(json.data);
                } else {
                    setModulePermissions({ privateMessaging: false });
                }
            } catch (error) {
                console.error("خطأ في جلب صلاحيات الوحدات:", error);
                setModulePermissions({ privateMessaging: false });
            } finally {
                setLoadingPermissions(false);
            }
        };

        fetchModulePermissions();
    }, [BASE_URL]);

    return { modulePermissions, loadingPermissions };
};

export default useModulePermissions;